// GTranslate's float switcher injects this img via its own JS (not filterable in PHP), so PageSpeed's explicit width/height check needs a DOM patch here.
const SetGtranslateFlagSize = () => {
	const flagSelector = '.gt-current-lang img';

	const setDimensions = (img) => {
		img.setAttribute('width', '33');
		img.setAttribute('height', '33');
	};

	const existingFlag = document.querySelector(flagSelector);

	if (existingFlag) {
		setDimensions(existingFlag);

		return;
	}

	const observer = new MutationObserver((mutations, obs) => {
		const flag = document.querySelector(flagSelector);

		if (!flag) {
			return;
		}

		setDimensions(flag);
		obs.disconnect();
	});

	observer.observe(document.body, { childList: true, subtree: true });
};

export default SetGtranslateFlagSize;
